module.exports = __webpack_public_path__ + "static/img/2222.32a900a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/2222.jpg
// module id = TaMR
// module chunks = 1